import { render, staticRenderFns } from "./QuacksData.vue?vue&type=template&id=50d883cb"
import script from "./QuacksData.vue?vue&type=script&lang=js"
export * from "./QuacksData.vue?vue&type=script&lang=js"
import style0 from "./QuacksData.vue?vue&type=style&index=0&id=50d883cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports